import React, { useMemo } from "react";
import Section from "./Section";

const Timeline = ({ order }) => {
  const timeline = useMemo(() => {
    const events = [];

    const STATUS_LABELS = {
      pending: "Order received",
      preparing: "Kitchen is preparing your order",
      ready: "Ready for pickup",
      completed: "Order completed",
      cancelled: "Order cancelled",
      paid: "Payment successful",
    };

    // 🟢 Order created
    events.push({
      label: "Order placed",
      date: order.createdAt,
      type: "order",
      status: "created",
    });

    // 🟡 Order status history
    order.orderStatusHistory?.forEach((item) => {
      events.push({
        label: STATUS_LABELS[item.status] || item.status,
        date: item.changedAt,
        type: "order",
        status: item.status,
      });
    });

    // 💰 Payment history
    order.payments?.paymentStatusHistory?.forEach((item) => {
      events.push({
        label: STATUS_LABELS[item.status] || `Payment ${item.status}`,
        date: item.changedAt,
        type: "payment",
        status: item.status,
      });
    });

    // 🔥 Sort newest → oldest
    const sorted = events.sort((a, b) => new Date(b.date) - new Date(a.date));

    // 🔥 GROUP BY DATE
    const grouped = {};

    sorted.forEach((item) => {
      const dateKey = new Date(item.date).toLocaleDateString("en-NZ", {
        day: "numeric",
        month: "long",
      });

      if (!grouped[dateKey]) grouped[dateKey] = [];
      grouped[dateKey].push(item);
    });

    return grouped;
  }, [order]);

  const formatTime = (date) => {
    return new Date(date).toLocaleTimeString("en-NZ", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // 🎨 Status color helper
  const getStatusColor = (status) => {
    switch (status) {
      case "paid":
        return "text-green-600";
      case "preparing":
        return "text-orange-500";
      case "ready":
        return "text-blue-500";
      case "completed":
        return "text-green-700";
      case "cancelled":
        return "text-red-500";
      default:
        return "text-gray-800";
    }
  };

  return (
    <div className="">
      <div className="relative border-l border-gray-200 ml-2">
        {Object.entries(timeline).map(([date, items]) => (
          <div key={date} className="mb-6">
            {/* 🗓 DATE HEADER */}
            <p className="text-sm font-semibold text-gray-600 ml-4 mb-3">
              {date}
            </p>

            {items.map((item, index) => (
              <div key={index} className="mb-4 ml-4 relative">
                {/* Dot */}
                <div className="absolute w-2 h-2 bg-black rounded-full -left-[20px] top-1.5" />

                {/* Time */}
                <p className="text-xs text-gray-400">{formatTime(item.date)}</p>

                {/* Label */}
                <p
                  className={`text-sm font-medium ${getStatusColor(
                    item.status,
                  )}`}
                >
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Timeline;
